import { useToast, UseToastOptions } from "@chakra-ui/react"
import { useCallback } from "react";

type Content = {
  description: string;
  title: any;
  id?: string;
  duration?: number,
}

export const useToastNotification = () => {
  const toast = useToast();

  const baseNotif: Partial<UseToastOptions> = {
    duration: 5000,
    isClosable: true,
    position: 'top-right',
  }

  const successToast = useCallback((content: Partial<Content>) => toast({ ...baseNotif, status: 'success', ...content }), [toast]);
  const errorToast = useCallback((content: Partial<Content>) => toast({ ...baseNotif, status: 'error', ...content }), [toast]);;
  const infoToast = useCallback((content: Partial<Content>) => toast({ ...baseNotif, status: 'info', ...content }), [toast]);;

  return {
    successToast,
    errorToast,
    infoToast,
  };
};
